import { SideBarItem } from '@/services/models/nav-bar';
import { dynamicTextIdTemplate } from '@/utils/string/get-dynamic-text-id';

type ObjectItem = {
  title: string;
}

function getNavBarItems<T extends Record<string, ObjectItem | null> | null>(
  content: T,
  textContent?: ObjectItem[] | null,
  textContentPosition = 0
) {
  const SideBarItems: SideBarItem[] = [];

  if (content) {
    Object.entries(content).forEach(([key, item]) => {
      if (item && 'title' in item && key !== 'app_banner') {
        if (('list' in item && item.list) || ('description' in item && item.description)) {
          SideBarItems.push({
            name: item.title,
            id: key
          });
        }
      }
    });
  }

  if (textContent) {
    SideBarItems.splice(textContentPosition, 0, ...textContent.map((text, index) => (
      {
        name: text.title,
        id: dynamicTextIdTemplate(index)
      }
    )));
  }

  return SideBarItems;
}
export default getNavBarItems;
